import request from "@/utils/request";

/**
 * 获取首页信息
 *
 * @description 获取首页信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function home_index(playload) {
  return request({
    url: "/api/v2/home/index",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
//获取图片地址
export async function getLogos() {
  return request({
    url: "/api/v2/home/getLogos",
    method: "POST",
    data: {},
    noEncrypt: true
  });
}
